import { Icon, Intent, Position, Tag, Tooltip } from "@blueprintjs/core"
import { HasId, HTML } from "src/libs/interfaces/layouts"
import { __, __cases, sprintf } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILandingSection, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import updateSection from "../utils/updateSection"
import { showToast } from "src/libs/useful"
import { hideOver } from "./utils"

/* Protopia Ecosystem component */
export interface ISelectedElementsFormProps {
   
}
const SelectedElementsForm = (props: ISelectedElementsFormProps): JSX.Element => {
    const {
        currentLanding,
        selectedElements, 
        selectedElementsType,  
        selectedSectionId,
        onCopy,
    }	= useLandingStore((state: ILandingStore) => state) 

    const getLabel = (): HTML => {
        switch( selectedElementsType ) {
            case SELECT_TYPE.CONTENT:
                return `${__("Selected")}: ${selectedElements.length} ${ __cases( selectedElements.length, "meats") }`
            case SELECT_TYPE.FLOAT:
            default:
                return `${__("Selected")}: ${selectedElements.length}  ${ __cases( selectedElements.length, "floats") }`
        }
    }
    const deselect = () => {
        useLandingStore.setState({
            selectedElements: [],
            selectedElementsType: undefined,
            selectedSectionId: undefined, 
        })
        hideOver()
    }
    const remove = () => { 
        const section : ILandingSection = currentLanding.sections.find((sec: HasId) => sec.id === selectedSectionId)
        const prevData: ILandingSection = JSON.parse( JSON.stringify(section ) )
        const data: ILandingSection = JSON.parse( JSON.stringify(
            selectedElementsType === SELECT_TYPE.CONTENT
                ?
                {
                    ...section,
                    data: section.data.filter(meat => {
                        return !selectedElements.find((s: HasId) => s.id === meat.id)
                    })
                }
                :
                {
                    ...section,
                    floats: section.floats.filter(float => {
                        return !selectedElements.find((s: HasId) => s.id === float.id)
                    })
                }
        ) ) 
        updateSection(
            data,
            {
                type: HISTORY_TYPE.SECTION,
                data,
                prevData,
                title: "Remove elements from section"
            } as IHistoryStep
        )
        deselect()
    }
     const onCopyData = () => {
        onCopy( { data: selectedElements, jsonData: "selectedElements", selectedElementsType } )
        showToast({
            message: sprintf(__("Group of %s elements copied"), selectedElements.length ),
            intent: "success"
        })
        deselect()
    }
    return <div className='landing-select-layer-panel w-100'>
        <div className="d-flex pt-1 pl-1 small w-100 justify-content-between">
            <div className="d-flex px-2">
                { getLabel() }
            </div>
            <div className="d-flex px-2">
                <Tooltip
                    position={Position.TOP}
                    interactionKind="hover"
                    intent={Intent.PRIMARY}
                    content={ <div className="small letter-spacing-1">{__("Copy group")}</div> }
                    portalClassName="z-index-120" 
                >  
                    <Tag 
                        minimal 
                        size="medium" 
                        className="small text-light py-0 px-1 mb-1 mr-1 hover pointer" 
                        style={{height: 22}}
                        onClick={ onCopyData }
                    >  
                        <div className="d-flex align-items-center ">
                            <Icon icon="clipboard" size={ 9 } /> 
                        </div>
                    </Tag>
                </Tooltip>
                <Tooltip
                    position={Position.TOP}
                    interactionKind="hover"
                    intent={Intent.PRIMARY}
                    content={ <div className="small letter-spacing-1">{__("Deselect")}</div> }
                    portalClassName="z-index-120" 
                >                      
                    <Tag 
                        minimal 
                        size="medium" 
                        className="small text-light py-0 px-1 mb-1 mr-1 hover pointer" 
                        style={{height: 22}}
                        onClick={ deselect }
                    >  
                        <div className="d-flex align-items-center ">
                            <Icon icon="sweep" size={ 9 } /> 
                        </div>
                    </Tag>                    
                </Tooltip>
            </div>
            <div className="d-flex px-2">
                <Tooltip
                    position={Position.TOP}
                    interactionKind="hover"
                    intent={Intent.PRIMARY}
                    content={ <div className="small letter-spacing-1">{__("Remove group")}</div> }
                    portalClassName="z-index-120" 
                >  
                    <Tag 
                        minimal 
                        size="medium" 
                        className="small text-light py-0 px-1 mb-1 mr-1 hover pointer" 
                        style={{height: 22}}
                        onClick={remove}
                    >  
                        <div className="d-flex align-items-center ">
                            <Icon icon="trash" size={ 9 } /> 
                        </div>
                    </Tag>
                </Tooltip>
            </div>
        </div>
    </div>
}
export default SelectedElementsForm